import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { inject, ref, Ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useInternationalOffersTracking } from '../tracking';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import Provider from '@/interfaces/provider';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersDropdown',
  setup(__props) {

const searchPackages = inject<Ref<Provider[]>>('searchPackages', ref([]));
const filteredProviders = inject<Ref<Provider[]>>('filteredProviders', ref([]));
const setSearchPackages = inject<(providers: Provider[]) => void>('setSearchPackages', () => {});
const { trackInternationalOffers } = useInternationalOffersTracking({ title: null });

function openDropDown(event: Event) {
	trackInternationalOffers('streamingServiceDropdown');

	PopoverHelper.create({
		popoverProps: {
			cssClass: 'search-list__pop-over',
			boundingElement: event.currentTarget,
			anchor: 'left',
			position: 'left',
		},
		component: () => import('@/features/international-offers/components/ProviderSearchList.vue'),
		componentProps: {
			searchPackages: searchPackages?.value,
			filteredProviders: filteredProviders?.value,
			setSearchPackages: setSearchPackages,
		},
		onOpened: () => {
			trackInternationalOffers('serviceModalOpened');
		},
		onClosed: () => {
			const packageContexts = searchPackages.value.map(item =>
				TrackingHelper.getPackageContext(item.packageId, item.technicalName)
			);
			trackInternationalOffers('serviceModalClosed', { contexts: packageContexts });
		},
	});
}

return { __sfc: true,searchPackages, filteredProviders, setSearchPackages, trackInternationalOffers, openDropDown, BasicButton, faChevronDown }
}

})